import LandingPage from "../views/LandingPage/LandingPage.jsx"
import Faq from "../views/Faq/Faq.jsx"

const indexRoutes = [{ path: "/", name: "Faq", component: LandingPage }, { path: "/faq", name: "Faq", component: Faq }]

export default indexRoutes



// WEBPACK FOOTER //
// ./src/routes/index.jsx